import { defineStore } from 'pinia';
import { init } from "@/js/service/init";
import {readCookie, writeCookie} from "@/js/utils";

export const useStore = defineStore('main', {
    state: () => ({
        loadingApp: true,
        auth: false,
        user: {},
        alert: {
            visible: false,
            type: 'success',
            title: '',
            closable: true,
            message: ''
        },
        onboardingProgress: '',
    }),
    getters: {
        onboardingPassed: (state) => {
            return state.onboardingProgress === 'finished' || state.onboardingProgress === 'moderated';
        },
    },
    actions: {
        async getInitData() {
            this.loadingApp = true;
            if (readCookie('bearer_token')) {
                await this.init();
                this.loadingApp = false;
            } else {
                this.loadingApp = false;
                this.auth = false;
                writeCookie('auth', false, 30);
            }
        },
        async init() {
            try {
                let data = {
                    include: 'user'
                }
                const response = await init(data);
                writeCookie('auth', true, 30);
                this.auth = true;
            } catch (error) {
                writeCookie('auth', false, 30);
            }

        },

        handleAlert(type, title, closable, message, delay = false) {
            this.alert.visible = true;
            this.alert.type = type;
            this.alert.title = title;
            this.alert.closable = closable;
            this.alert.message = message;
            if (delay) {
                setTimeout(() => {
                    this.closeAlert();
                }, delay);
            }
        },
        closeAlert() {
            this.alert.visible = false;
        }
    }
})
